module.exports = __webpack_public_path__ + "img/4mbs-classic.b26df2d4.png";